import i18n from 'i18next';

import { getActionType } from 'app/providers/StoreProvider/middleware/dynamicCrumbs/utils/getActionType';
import { generatedGspApi } from 'shared/api/gsp';
import { RoutePath } from 'shared/constants/router';

import type {
  InspiredGlobalStudyPlatformApiModelsSubjectsGetSubjectOverviewResponse as Subject,
  InspiredGlobalStudyPlatformApiModelsAssignmentOverview as Assignment,
} from 'shared/api/gsp';

const {
  getApiSubjectsByStudentIdAndSubjectIdAssignmentsAssignmentId,
  getApiSubjectsByStudentIdAndSubjectIdOverview,
  getApiProgressByStudentIdAndSubjectId,
} = generatedGspApi.endpoints;

export const ENDPOINT_ROUTE_MAP = {
  [RoutePath.UpcomingAssignmentDetails]: {
    endpointName:
      getApiSubjectsByStudentIdAndSubjectIdAssignmentsAssignmentId.name,
    titleGetter: (assignment: Assignment) => [
      i18n.t('header.breadcrumbs.upcomingAssignments'),
      assignment.name,
    ],
  },
  [RoutePath.SubjectDetails]: {
    endpointName: getApiSubjectsByStudentIdAndSubjectIdOverview.name,
    titleGetter: (subject: Subject) => subject.name,
  },
  [RoutePath.AssignmentDetails]: {
    endpointName:
      getApiSubjectsByStudentIdAndSubjectIdAssignmentsAssignmentId.name,
    titleGetter: (assignment: Assignment) => [
      i18n.t('header.breadcrumbs.subjects.assignments'),
      assignment.name,
    ],
  },
  [RoutePath.ProgressSubject]: {
    endpointName: getApiProgressByStudentIdAndSubjectId.name,
    titleGetter: (subject: Subject) => subject.name,
  },
};

export const PENDING = getActionType('pending');
export const FULFILLED = getActionType('fulfilled');
export const REJECTED = getActionType('rejected');

export const ACTION_TYPES = [PENDING, FULFILLED, REJECTED];
